<template>
    <b-form-row class="dz-preview dz-file-preview">
        <b-col
                cols="8"
                md="9"
                class="left-items"
        >
            <div class="dz-image">
                <div
                        data-dz-thumbnail-bg
                        class="image-thumbnail"
                />
            </div>
            <div class="dz-details">
                <div class="dz-filename">
                    <span data-dz-name />
                </div>
            </div>
        </b-col>
        <b-col
                cols="4"
                md="3"
                class="right-items"
        >
            <div class="dz-progress">
                <div
                        class="dz-upload progress-bar progress-bar-success"
                        style="width:0%;"
                        data-dz-uploadprogress
                />
            </div>
            <div class="dz-error-message">
                <span
                        class="error-upload"
                        data-dz-errormessage
                />
            </div>
            <span
                    class="dz-remove fal fa-times"
                    data-dz-remove
            />
        </b-col>
    </b-form-row>
</template>

<script>
    export default {
        name: 'DropzoneTemplate'
    };
</script>

<style lang="scss">
    .dz-preview {
        .center-items {
            display:         flex;
            justify-content: center;
            align-items:     center;
        }

        .left-items {
            display:         flex;
            justify-content: flex-start;
            align-items:     center;
        }

        .right-items {
            display:         flex;
            justify-content: flex-end;
            align-items:     center;
        }
    }
</style>
